module.exports = __webpack_public_path__ + "img/London.d5cb4b2d.jpg";